module.exports = __webpack_public_path__ + "static/media/StatPayingCircle.000a4482.svg";